import * as React from "react";
import "./InitPasswordPage.scss";
import SetPassword from "../components/password/SetPassword";
/**
 * Stránka nastavení hesla po resetu.
 */

class PasswordChangePage extends React.Component<any> {
  handleLoginRedirect = () => {
    window.location.href = window.appConfig.serverContextPath + "/password-change/success";
  };

  render() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const code = urlParams.get("code");
    return <SetPassword code={code} onLoginRedirect={this.handleLoginRedirect} />;
  }
}

export default PasswordChangePage;
